import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import FullScreenDialog from "../../PopUp/FullScreendialogs/FullScreen";
import PopUpCSWAREHOUSEALL from "../../PopUp/PopUpwarehouseAll";
import { parseJwt } from "../../parseJWT";
import Tooltip from "@mui/material/Tooltip";

const useStyles = makeStyles({
  inputGroup: {
    position: "relative",
    display: "flex",
    borderCollapse: "separate",
    float: "left",
    paddingRight: 0,
    paddingLeft: 0,
    marginBottom: "5px",
    marginLeft: 0,
    paddingLeft: "15px",
    paddingRight: "15px",
    minWidth: "50%",
  },
  inputgroupaddon: {
    minWidth: "100px",
    width: "100px",
    padding: "5px",
    fontsize: "15px",
    fontWeight: "700",
    lineHeight: "1",
    color: "#555",
    textAlign: "center",
    backgroundColor: "#eee",
    border: "1px solid #ccc",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    display: "table-cell",
    borderCollapse: "separate",
  },
  input: {
    "& .MuiInputBase-input": {
      borderRadius: "0px",
      padding: "5px",
      fontSize: "14px",
      fontFamily: "Customfont",
      // width:'80%'
    },
  },
});
export default function CustomInputtext(props) {
  const classes = useStyles();
  const {
    title,
    value,
    disabledvalue,
    of_title,
    of_btn,
    of_btnrefresh,
    //  propsvalue,
    source,
    fullWidth,
    id,
  } = props;
  const [values, setValues] = React.useState({});
  const [openFullScreenDialog, setopenFullScreenDialog] = React.useState();
  const [titleFullScreenDialog, settitleFullScreenDialog] = React.useState();
  const [warehouse, setwarehouse] = React.useState();
  const [location, setlocation] = React.useState();

  useEffect(() => {
    setValues(value);
  }, [value]);

  useEffect(() => {
    if (!value) {
      if (source === "CSWAREHOUSEALL") {
        let SITECODESTR = parseJwt(localStorage.getItem("Token"));
        setwarehouse(SITECODESTR.User.SITECODE);
        setlocation(SITECODESTR.User.SITECODE + "001");
        setValues(
          "รหัสคลัง: " +
            SITECODESTR.User.SITECODE +
            "  รหัสที่เก็บ: " +
            SITECODESTR.User.SITECODE +
            "001"
        );
        props.propsvalue({
          source: "CSWAREHOUSEALL",
          warehouse: SITECODESTR.User.SITECODE,
          location: SITECODESTR.User.SITECODE + "001",
        });
      }
    }
  }, [source]);
  const handleChange = (event) => {
    setValues(event.target.value);
  };
  const onblur = (event) => {
    props.propsvalue(event.target.value);
  };
  const clickbtn = () => {
    //open
    setopenFullScreenDialog(true);
    //title
    settitleFullScreenDialog("กำหนดคลังเริ่มต้น");
  };
  const clickbtnrefresh = (e) => {
    if (source === "CSWAREHOUSEALL") {
      GetPopUpwarehouseAll("");
    }
  };
  // คืนค่าจากคลังเริ่มต้น
  const GetPopUpwarehouseAll = (data) => {
    if (data) {
      setValues(
        "รหัสคลัง: " + data.warehouse + "  รหัสที่เก็บ: " + data.location
      );
      props.propsvalue({
        source: "CSWAREHOUSEALL",
        warehouse: data.warehouse,
        location: data.location,
      });
    } else {
      setValues("รหัสคลัง: " + warehouse + "  รหัสที่เก็บ: " + location);
      props.propsvalue({
        source: "CSWAREHOUSEALL",
        warehouse: warehouse,
        location: location,
      });
    }
    setopenFullScreenDialog(false);
  };
  const CloseDialog = (e) => {
    setopenFullScreenDialog(e);
  };
  return (
    <div>
      <FullScreenDialog
        open={openFullScreenDialog}
        title={titleFullScreenDialog}
        closeDialog={(e) => CloseDialog(e)}
      >
        {source === "CSWAREHOUSEALL" ? (
          <PopUpCSWAREHOUSEALL GetPopUpwarehouseAll={GetPopUpwarehouseAll} />
        ) : (
          ""
        )}
      </FullScreenDialog>
      <Tooltip title={"รหัสคลัง: " + warehouse + "  รหัสที่เก็บ: " + location}>
        <div className={classes.inputGroup}>
          {!of_title ? (
            <span className={classes.inputgroupaddon}> {title} </span>
          ) : (
            ""
          )}
          <TextField
            id={`TextField${id}`}
            variant="outlined"
            fullWidth={fullWidth}
            className={classes.input}
            disabled={disabledvalue}
            value={values}
            label="-"
            onChange={handleChange}
            onBlur={onblur}
          />
          {!of_btn ? (
            <IconButton
              id={`SearchIcon${id}`}
              type="submit"
              sx={{
                p: "3px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "30px",
              }}
              aria-label="search"
              onClick={clickbtn}
            >
              <SearchIcon sx={{ fontSize: "20px" }} />
            </IconButton>
          ) : (
            ""
          )}
          {!of_btnrefresh ? (
            <IconButton
              id={`refreshIcon${id}`}
              color="primary"
              sx={{
                p: "3px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "30px",
              }}
              aria-label="directions"
              onClick={clickbtnrefresh}
            >
              <CachedOutlinedIcon sx={{ fontSize: "20px", color: "#555" }} />
            </IconButton>
          ) : (
            ""
          )}
        </div>
      </Tooltip>
    </div>
  );
}
CustomInputtext.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  disabledvalue: PropTypes.bool,
  of_title: PropTypes.bool,
  of_btn: PropTypes.bool,
  of_btnrefresh: PropTypes.bool,
  //propsvalue: PropTypes.string,
  source: PropTypes.string,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
};
